<template>
  <div
    class="w-full max-w-192 h-screen relative overflow-hidden flex flex-col items-center justify-center -mt-17vh"
  >
    <transition name="fadeUp">
      <div
        v-if="pageNumber === 1"
        style="animation-duration: 0.5s"
        class="nav-title-wrapper w-full flex items-center justify-center 2xl:w-full xl:w-6/12 lg:w-5/12"
      >
        <img :src="`${imgPath}/Section02/title_01.png`" />
      </div>
    </transition>

    <transition-group
      name="fadeUp"
      tag="div"
      class="nav-container relative w-full lg:max-w-928 flex justify-center mt-7vh"
    >
      <div
        v-if="pageNumber === 1"
        :style="delayAnimation(index)"
        class="nav-btn relative 2xl:w-33.9 2xl:h-37.4 lg:w-210 lg:h-235"
        v-for="(nav, index) in navData"
        :key="nav"
      >
        <div
          class="nav-btn-bg absolute w-full h-full mx-auto inset-x-0 cursor-pointer 2xl:bg-auto xl:bg-cover lg:bg-cover bg-no-repeat 2xl:bg-10-10 lg:bg-0-0"
          :style="{
            'background-image':
              'url(' + imgPath + '/Section02/nav' + (index + 1) + '.png)',
          }"
          @click="moveTo(nav)"
        >
          <span
            class="nav-btn-hover"
            :style="{
              'background-image':
                'url(' + imgPath + '/Section02/nav' + (index + 1) + '.png)',
            }"
          ></span>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: ['moveTo'],
  data: function() {
    return {
      navData: [3, 4, 5, 7, 8],
    };
  },
  methods: {
    delayAnimation: function(index) {
      //console.log(index);
      if (index === 0) {
        return 'animation-duration: 0.5s';
      }
      if (index === 1) {
        return 'animation-duration: 1s';
      }
      if (index === 2) {
        return 'animation-duration: 1.5';
      }
      if (index === 3) {
        return 'animation-duration: 2s';
      }
      if (index === 4) {
        return 'animation-duration: 2.5s';
      }
    },
  },
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
      pageNumber: state => state.AppConfig.pageNumber,
    }),
  },
};
</script>

<style lang="postcss" scoped>
.nav-btn:nth-child(1) .nav-btn-bg {
  @apply -right-4/10;
}
.nav-btn:nth-child(2) .nav-btn-bg {
  @apply -bottom-3/10 -right-2/10;
}
.nav-btn:nth-child(4) .nav-btn-bg {
  @apply -bottom-3/10 -left-2/10;
}
.nav-btn:nth-child(5) .nav-btn-bg {
  @apply -left-4/10;
}
.nav-btn-bg {
  text-indent: -9999px;
}
.nav-btn-bg span {
  @apply absolute inset-0 2xl:bg-358-10 lg:bg-213-0 2xl:bg-auto lg:bg-cover bg-no-repeat;
  content: '';
  opacity: 0;
  -webkit-transition: opacity 0.5s;
  -moz-transition: opacity 0.5s;
  -o-transition: opacity 0.5s;
}
.nav-btn:hover .nav-btn-bg span {
  opacity: 1;
}
</style>
